module.exports = __webpack_public_path__ + "img/nps-success-check.85eec7fc.svg";